<div [formGroup]="form" class="filter-container">
  <mat-form-field style="margin-left: 2px">
    <mat-label>{{ 'funding.year' | translate }}</mat-label>
    <mat-select formControlName="year">
      @for(item of yearItems(); track item.key) {
      <mat-option [value]="item.key">{{ item.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
